import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { auth, db, increment } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#F7F5F0',
    padding: '2rem',
  },
  container: {
    maxWidth: '960px',
    margin: '0 auto',
    display: 'grid',
    gap: '1.5rem',
  },
  backLink: {
    display: 'inline-block',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#4A9E8A',
    textDecoration: 'none',
    marginBottom: '1rem',
  },
  mainCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    overflow: 'hidden',
    border: '1px solid #E0DDD6',
    boxShadow: '0 18px 60px rgba(17, 17, 16, 0.08)',
  },
  imageWrapper: {
    width: '100%',
    minHeight: '360px',
    backgroundColor: '#EDEBE7',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  thumbnailStrip: {
    display: 'flex',
    gap: '0.5rem',
    padding: '1rem',
    overflowX: 'auto',
    backgroundColor: '#F7F5F0',
  },
  thumbnail: {
    width: '80px',
    height: '60px',
    borderRadius: '6px',
    overflow: 'hidden',
    cursor: 'pointer',
    border: '2px solid transparent',
    flexShrink: 0,
  },
  thumbnailActive: {
    borderColor: '#4A9E8A',
  },
  thumbnailImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  content: {
    padding: '2rem',
  },
  badge: {
    display: 'inline-block',
    marginBottom: '1rem',
    padding: '7px 14px',
    borderRadius: '999px',
    backgroundColor: '#F4F2ED',
    color: '#6E6B62',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
  title: {
    margin: '0 0 0.75rem',
    fontFamily: 'Playfair Display, Georgia, serif',
    fontSize: '2rem',
    color: '#111110',
    lineHeight: 1.1,
  },
  meta: {
    margin: 0,
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#555553',
    lineHeight: 1.8,
  },
  description: {
    margin: '1.5rem 0 0',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '15px',
    color: '#444441',
    lineHeight: 1.8,
  },
  sidebar: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '2rem',
    border: '1px solid #E0DDD6',
    boxShadow: '0 18px 60px rgba(17, 17, 16, 0.08)',
  },
  sectionTitle: {
    margin: '0 0 1rem',
    fontFamily: 'Playfair Display, Georgia, serif',
    fontSize: '1.4rem',
    color: '#111110',
  },
  label: {
    display: 'block',
    marginBottom: '0.35rem',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#444441',
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '10px',
    border: '1px solid #E0DDD6',
    backgroundColor: '#FFFFFF',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#111110',
    outline: 'none',
    marginBottom: '1rem',
  },
  textarea: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '10px',
    border: '1px solid #E0DDD6',
    backgroundColor: '#FFFFFF',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#111110',
    outline: 'none',
    minHeight: '140px',
    marginBottom: '1rem',
    resize: 'vertical',
  },
  submitBtn: {
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: 'none',
    backgroundColor: '#4A9E8A',
    color: '#F7F5F0',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    cursor: 'pointer',
  },
  note: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#888880',
    marginBottom: '1rem',
  },
  error: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#E24B4A',
    marginBottom: '1rem',
  },
  success: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#336633',
    marginBottom: '1rem',
  },
  successCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '1.5rem 0',
    gap: '1rem',
  },
  successIcon: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    backgroundColor: '#E8F5F1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
  },
  successHeading: {
    margin: 0,
    fontFamily: 'Playfair Display, Georgia, serif',
    fontSize: '1.3rem',
    color: '#111110',
  },
  successBody: {
    margin: 0,
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#555553',
    lineHeight: 1.7,
  },
  continuBtn: {
    marginTop: '0.5rem',
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: 'none',
    backgroundColor: '#4A9E8A',
    color: '#F7F5F0',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '1.5rem',
  },
  smallMeta: {
    margin: '0.75rem 0 0',
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#555553',
  },
};

function ListingDetail() {
  const { id } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        setName(currentUser.displayName || '');
        setEmail(currentUser.email || '');
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchListing = async () => {
      setLoading(true);
      setError('');
      try {
        const docRef = doc(db, 'listings', id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const listingData = { id: docSnap.id, ...docSnap.data() };
          setListing(listingData);

          // Increment viewCount if current user is not the owner
          if (user && user.uid !== listingData.userId) {
            try {
              await updateDoc(docRef, {
                viewCount: increment(1)
              });
            } catch (updateError) {
              console.error('Error incrementing view count:', updateError);
            }
          }
        } else {
          setError('Listing not found.');
        }
      } catch (fetchError) {
        console.error('ListingDetail fetch error', fetchError);
        setError('Unable to load listing details. Please refresh the page.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchListing();
    }
  }, [id, user]);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!name.trim() || !email.trim() || !message.trim()) {
      setError('Please fill in your name, email, and message.');
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email.trim())) {
      setError('Please enter a valid email address.');
      return;
    }

    if (!listing) {
      setError('Listing is not loaded yet.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch('https://iigathw6ize3lhultdoag4qxmq0uptro.lambda-url.us-east-1.on.aws/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          listingId: listing.id,
          buyerName: name.trim(),
          buyerEmail: email.trim(),
          message: message.trim(),
        }),
      });

      if (!response.ok) throw new Error('Failed to send message');

      setSuccess('Your message has been sent. The seller will reply to your email directly.');
      setMessage('');
    } catch (submitError) {
      console.error('ListingDetail submit error', submitError);
      setError('Unable to send your message. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <main style={styles.page}>
        <p style={styles.error}>Loading listing…</p>
      </main>
    );
  }

  if (error) {
    return (
      <main style={styles.page}>
        <div style={styles.container}>
          <Link to="/" style={styles.backLink}>&larr; Back to home</Link>
          <p style={styles.error}>{error}</p>
        </div>
      </main>
    );
  }

  return (
    <main style={styles.page}>
      <div style={styles.container}>
        <Link to="/" style={styles.backLink}>&larr; Back to home</Link>

        <div style={styles.grid}>
          <article style={styles.mainCard}>
            <div style={styles.imageWrapper}>
              <img
                src={
                  (listing.images?.[activeImageIndex]?.full) ||
                  (listing.images?.[activeImageIndex]?.gallery) ||
                  listing.imageUrl ||
                  'https://via.placeholder.com/900x520?text=HostelChic'
                }
                alt={`${listing.title} - Image ${activeImageIndex + 1}`}
                style={styles.image}
              />
            </div>
            {listing.images && listing.images.length > 0 && (
              <div style={styles.thumbnailStrip}>
                {listing.images.map((img, idx) => (
                  <div
                    key={idx}
                    style={{
                      ...styles.thumbnail,
                      ...(idx === activeImageIndex ? styles.thumbnailActive : {})
                    }}
                    onClick={() => setActiveImageIndex(idx)}
                  >
                    <img
                      src={img.thumbnail || img.gallery}
                      alt={`Thumbnail ${idx + 1}`}
                      style={styles.thumbnailImg}
                    />
                  </div>
                ))}
              </div>
            )}
            <div style={styles.content}>
              <span style={styles.badge}>
                {listing.category === 'stays' ? 'Stay' : 'Marketplace'}
              </span>
              <h1 style={styles.title}>{listing.title}</h1>
              <p style={styles.meta}>{listing.location}</p>
              <p style={styles.meta}>${listing.price} {listing.category === 'stays' && `/ ${listing.priceType || 'night'}`}</p>
              {listing.userName && (
                <p style={styles.smallMeta}>Posted by {listing.userName}</p>
              )}
              <p style={styles.description}>{listing.description}</p>
            </div>
          </article>

          <aside style={styles.sidebar}>
            {success ? (
              <div style={styles.successCard}>
                <div style={styles.successIcon}>✓</div>
                <h2 style={styles.successHeading}>Message sent!</h2>
                <p style={styles.successBody}>
                  Your inquiry is on its way. The seller will reply directly to your email — check your inbox soon.
                </p>
                <Link to="/" style={styles.continuBtn}>Continue Browsing</Link>
              </div>
            ) : (
              <>
                <h2 style={styles.sectionTitle}>Contact seller</h2>
                <p style={styles.note}>
                  Use this form to send a private inquiry. No seller email or phone is shared publicly.
                </p>
                {error && <p style={styles.error}>{error}</p>}
                <form onSubmit={handleContactSubmit}>
                  <label style={styles.label} htmlFor="contact-name">Name</label>
                  <input
                    id="contact-name"
                    style={styles.input}
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name"
                    required
                  />

                  <label style={styles.label} htmlFor="contact-email">Email</label>
                  <input
                    id="contact-email"
                    style={styles.input}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                  />

                  <label style={styles.label} htmlFor="contact-message">Message</label>
                  <textarea
                    id="contact-message"
                    style={styles.textarea}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Ask the seller about availability, details, or pickup.">
                  </textarea>

                  <button style={styles.submitBtn} type="submit" disabled={submitting}>
                    {submitting ? 'Sending…' : 'Send message'}
                  </button>
                </form>
              </>
            )}
          </aside>
        </div>
      </div>
    </main>
  );
}

export default ListingDetail;